export default __webpack_public_path__ + "static/ds-theming-design-tokens-5c35f512c4a72e4063838399a2a00c31.png";